<template>
  <div id="Forget_password">
    <div class="forget_password_box">
      <Title title_name="忘記密碼"></Title>
      <div class="info">
          請輸入您註冊的E-Mail(帳號)，我們會發送一封  「<span>重設密碼通知信</span>」給您；<br />
          請至您的email信箱收取「<span>重設密碼通知信</span>」，依信件指示登入會員中心並修改密碼
      </div>
      <div>
        <form>
          <InputBox v-for="(item, index) in input_info.slice(2, 3)" :key="item.input_id" :input_info="input_info.slice(2, 3)[index]" @input_content="input_content"></InputBox>
        </form>
        <div class="content" v-if="this.content !='' ">
          {{content}}
        </div>
        <MoreButton button_text="查詢" @click.native="submit_forget_password" button_href="javascript:void(0);" :loading="loading"></MoreButton>
        <MoreButton v-if="content" button_text="回首頁" button_href="/"></MoreButton>
        <div class="notice">
          <span>請注意</span><br />
          <ul>
            <li>因各家email信箱的收件效率不同，請您耐心等候，若5分鐘後尚未收到信件，請再次操作。</li>
            <li>使用Yahoo、PChome、Hotmail等免費信箱，信件有可能被誤判為垃圾信，請先至「垃圾信匣」查看，若仍收不到，請重新操作。</li>
            <li>如您有任何問題，請撥客服電話02-2759-7167，我們會盡最大的努力儘快作回覆。</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Title from "@/components/base/Title"
import InputBox from "@/components/base/InputBox"
import MoreButton from "@/components/base/MoreButton"
export default {
  name: "forget_password",
  components: {
    Title: Title,
    InputBox: InputBox,
    MoreButton: MoreButton,
  },
  data() {
    return {
      input_info:require('@/plugins/input_info'), //input資料
      member_info:{
        email: '',
      },
      content:'',
      loading: false,
    }
  },
  computed: {
    API() {
      return process.env.NODE_ENV === 'production' ? 'https://www.top-link.com.tw/' : 'http://localhost/'
    }
  },
  methods: {
    input_content(v) {
      this.member_info[v[1]] = v[0]
    },
    submit_forget_password() {
      var vm = this;
      var forget_account_api = vm.API + 'api/member/forget/password'
      vm.loading = true
      vm.axios.post(forget_account_api, vm.member_info).then(res => {
        // console.log(res);
        if(res.data.status == 200){
          vm.loading = false
          vm.content = "「重設密碼通知信」已寄出!"
        }
        else {
          alert('錯誤碼: ' +res.data.status + res.data.message)
          vm.loading = false
        }
      }).catch(function(error) {
          console.log(error)
        })
    }
  }
}
</script>
<style>
  .forget_password_box{
    width: 650px;
    height: auto;
    max-width: 100%;
    margin: auto;
    padding: 20px;
  }
  .info{
    font-size: 18px;
    line-height: 2;
    padding: 10px 0;
  }
  .info span {
    color: red;
    font-weight: bold;
  }
  .notice{
    border-top: 1px solid black;
    padding-top: 15px;
    font-size: 16px;
    line-height: 1.5;
    text-align: center;
  }
  .notice span{
    font-weight: bold; 
    font-size: 22px;
  }
  .notice ul{
    text-align: justify;
    padding: 0 10px;
  }
  .notice li{
    padding: 8px 0;
  }
  .content{
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    padding: 18px 0;
    margin:  0 20px 10px 20px;
    background: antiquewhite;
  }
</style>